import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link as MaterialLink } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { UserContext } from './UserContext';
import { useTheme } from './ThemeContext';

import { AuthMenu, LoginMenu } from './Menu';
import { canAccessOrgAdmin } from './Common';

// Import both logo variants
const logoLight = require('../images/safer-logo.png');
const logoDark = require('../images/safer-logo.png');

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#0a0a0a' : 'white',
  margin: 0,
  padding: 0,
}));

const StyledLogo = styled('img')({
  paddingLeft: 0,
  paddingTop: '8px',
  paddingBottom: 0,
});

const StyledTab = styled(Tab)({
  paddingTop: '8px',
  paddingBottom: 0,
  minWidth: 'auto',
  '&.Mui-selected': {
    color: '#7591f6',
  },
  '&.MuiTab-root': {
    color: 'inherit',
  },
});

// Dark mode switch component
const DarkModeSwitch = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <FormControlLabel
      control={
        <Switch
          checked={darkMode}
          onChange={toggleDarkMode}
          size="small"
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#7591f6',
              '&:hover': {
                backgroundColor: 'rgba(117, 145, 246, 0.08)',
              },
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#7591f6',
            },
          }}
        />
      }
      label="🌙"
      labelPlacement="start"
      style={{
        marginLeft: '1rem',
        marginRight: '0.5rem',
        fontSize: '0.8rem'
      }}
    />
  );
};

// Logo component that uses theme context
const ThemeAwareLogo = () => {
  const { darkMode } = useTheme();
  const logo = darkMode ? logoDark : logoLight;

  return (
    <StyledLogo
      width={80}
      src={logo}
      alt="Safe Reaction"
    />
  );
};

class Topbar extends Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = { value: 0 };
    this.renderToolbar = this.renderToolbar.bind(this);
    this.menu = undefined;
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  current = () => {
    const { location } = this.props;
    let largestMatch = this.menu.map((m, i) => {
      let length = 0;
      if (location.pathname.startsWith(m.pathname))
        length = m.pathname.length;
      return {index: i, length: length};
    }).sort((a, b) => a.length < b.length ? 1 : -1)[0];
    if (largestMatch.length > 0)
      return largestMatch.index;
    else
      return this.menu.findIndex(m => m.pathname.endsWith('login'));
  };

  renderToolbar() {
    const { location } = this.props;
    const { value: stateValue } = this.state;
    const user = this.context;
    this.menu = (user.profile !== undefined) ? AuthMenu : LoginMenu;
    if (user.profile && user.profile.org === 'famb') {
      // remove annotation menus for Famb customers
      this.menu = this.menu.filter(item => item.label !== 'Annotations');
    }
    if (!user.profile || user.profile.org !== 'master') {
      this.menu = this.menu.filter(item => item.label !== 'Chat');
    }
    if (!canAccessOrgAdmin(user.profile)) {
      this.menu = this.menu.filter(item => item.label !== 'Settings');
    }
    return (
      <Toolbar style={{paddingLeft: '20px', paddingRight: '5px'}}>
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            alignItems: 'center'}}>
          <div style={{display: 'flex'}}>
            <div>
              <Link to="/">
                <ThemeAwareLogo />
              </Link>
            </div>
            <div style={{ marginLeft: 30 }}>
              <Tabs
                value={this.current() || stateValue}
                indicatorColor="primary"
                textColor="primary"
                onChange={this.handleChange}
                sx={{
                  '& .MuiTabs-indicator': {
                    backgroundColor: '#7591f6',
                  },
                }}
              >
                { this.menu.map((item) => (
                  item.label === 'Logout' ? (
                    <StyledTab
                      key={item.pathname}
                      label={item.label}
                      onClick={() => {
                        this.props.history.push('/login');
                      }}
                    />
                  ) : (
                  <StyledTab
                    key={item.pathname}
                    component={item.external ? MaterialLink : Link}
                    href={item.external ? item.pathname : null}
                    to={
                      item.external
                        ? null
                        : {
                            pathname: item.pathname,
                            search: location.search,
                          }
                    }
                    label={item.label}
                  />
                )))}
              </Tabs>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DarkModeSwitch />
            <div style={{ fontSize: "70%", fontStyle: "italic", paddingLeft: "1rem",
                paddingTop: '0.7rem', paddingRight: '0.5rem', textAlign: 'right' }}>
              {user.profile && (<>
                <nobr>Welcome {user.profile.givenName}!</nobr><br/>
                <nobr>{user.profile.email}</nobr><br/>
              </>)}
            </div>
          </div>
        </div>
      </Toolbar>
    );
  }

  render() {
    return (
      <StyledAppBar position="static" color="default">
        {this.renderToolbar()}
      </StyledAppBar>
    );
  }
}

export default withRouter(Topbar);
